var a = /* @__PURE__ */function (r) {
  return r.PRIMARY = "primary", r.SECONDARY = "secondary", r.TERTIARY = "tertiary", r.POSITIVE = "positive", r.NEGATIVE = "negative", r;
}(a || {});
export { a as r };